import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonAuthComponent from './CommonAuthComponent';

const ConfirmedNewInviteSent = () => {
  const navigate = useNavigate();

  const handleOkay = () => {
    navigate('/login');
  };

  return (
    <CommonAuthComponent maxWidthClass="max-w-md">
      <div className="flex flex-col items-center space-y-3">
        {/* Heading */}
        <h1 className="text-[28px] text-center font-normal mt-2 mb-4">
          Confirmed New Link Sent
        </h1>

        {/* Body */}
        <p className="text-center leading-relaxed text-[18px] font-normal !mt-4 !mb-4 px-2">
          We’ve sent a new invitation link to your email. Please check your inbox
          (and spam folder if needed)
        </p>

        {/* Security note */}
        <p className="text-center text-[14px] text-gray-600 !mt-3">For security, invitation reset link expires after 15 minutes</p>

        {/* CTAs */}
        <div className="w-full mt-2">
          <button
            onClick={handleOkay}
            className="w-full inline-flex rounded-[4px] border transition-all duration-300 text-body-md items-center font-semibold justify-center px-6 py-3.5 bg-REELTeal border border-transparent hover:bg-teal-200 text-white"
          >
            Okay
          </button>
          <button
            onClick={() => navigate('/login')}
            className="w-full inline-flex rounded-[4px] border transition-all duration-300 text-body-md items-center font-semibold justify-center px-6 py-3.5 bg-white border border-gray-300 hover:bg-gray-50 text-teal-900 mt-3"
          >
            Cancel
          </button>
        </div>
      </div>
    </CommonAuthComponent>
  );
};

export default ConfirmedNewInviteSent;
